<template>
  <form 
    class="animated fadeIn" 
    @submit.prevent="submit()">
    <h1>Forgot Password</h1>
    <p class="text-muted">Enter your email address to reset your password.</p>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text"><i class="icon-user"/></span>
      </div>
      <input 
        v-model="username" 
        type="email" 
        class="form-control" 
        placeholder="Email" 
        required>
    </div>
    <div class="row mb-3">
      <div class="col">
        <small 
          v-show="requestFailed" 
          class="text-danger">{{ msg.errorMsg }}</small>
        <small 
          v-show="requestSuccess" 
          class="text-success">{{ msg.successMsg }}</small>
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <button 
          :disabled="isFetching" 
          type="submit" 
          class="btn btn-primary px-4">Submit</button>
      </div>
      <div class="col-6 text-right">
        <router-link 
          :to="{ name: 'Login', query: urlQuery }" 
          class="px-0">Back to Login</router-link>
      </div>
    </div>
  </form>
</template>

<script>
import auth from '@/services/auth.service'

export default {
  name: 'ForgotPassword',
  data () {
    return {
      username: '',
      msg: Object,
      isFetching: false,
      requestFailed: false,
      requestSuccess: false
    }
  },
  computed: {
    urlQuery () {
      let params = this.$route.query
      return params
    }
  },
  methods: {
    submit () {
      this.isFetching = true
      this.requestFailed = false
      this.requestSuccess = false
      auth.requestResetPassword(this.username).then(
        (resp) => {
          this.isFetching = false
          this.requestSuccess = true
          this.msg.successMsg = resp.data.msgContent
        },
        (err) => {
          this.isFetching = false
          this.requestFailed = true
          this.msg.errorMsg = err.response.data.msgContent
        }
      )
    }
  },
}
</script>
